(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dd-quantity-packs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dd-quantity-packs')) {
    customElements.define('dd-quantity-packs', class extends HTMLElement {
      connectedCallback() {
        this.onChange = () => this.update();
        this.addEventListener('change', this.onChange);
        this.update();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
      }

      update() {
        const selected = this.querySelector('input[name="quantity"]:checked');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!selected || !price) return;
        price.querySelectorAll('.pi-price__current, .price__regular span.price-item--regular, .price-item--sale').forEach(node => {
          node.textContent = selected.dataset.packTotal;
        });
        price.querySelectorAll('s.price-item').forEach(node => {
          node.textContent = selected.dataset.packCompare;
        });
        this.dispatchEvent(new CustomEvent('dd:quantity-change', { bubbles: true }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
